import Vue from 'vue';
import vuescroll from 'vuescroll';
import { Popover } from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';

// 全剧样式
import '@/styles/index.scss';
import '@/styles/font/font.scss';
import '@/promise';
// element样式
import 'element-ui/lib/theme-chalk/index.css';
// 虚拟滚动条样式
import 'vuescroll/dist/vuescroll.css';

Vue.use(Popover);

// 你可以在这里设置全局配置
Vue.use(vuescroll, {
  ops: {
    rail: {
      opacity: '0',
      size: '6px',
      border: 'none',
      gutterOfEnds: '0',
    },
    bar: {
      background: '#e4e4e4',
      keepShow: false,
      size: '6px',
    },
    scrollButton: {
      // enable: false,
    },
    scrollPanel: {
      easing: 'easeInQuad',
      speed: 800,
    },
  }, // 在这里设置全局默认配置
  name: 'VueScroll', // 在这里自定义组件名字，默认是vueScroll
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
